// extracted by mini-css-extract-plugin
export default {"avgText":"SelectionOfYearsForTheAverageCalculation_avgText__r1QG5","group":"SelectionOfYearsForTheAverageCalculation_group__MdmoG"};